import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddOldCarFlow.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";
import StepIndicator from "./Common/StepIndicator";

export default function Overview(props) {
  const dispatch = useDispatch();

  const [registerationYear, setRegisterationYear] = useState("");
  const [manufacturingYear, setManufacturingYear] = useState("");
  const [owners, setOwners] = useState("");
  const [transmission, setTransmission] = useState("");
  const [color, setColor] = useState("");
  const [insurance, setInsurance] = useState("");
  const [registerationType, setregisterationType] = useState("");
  const [description, setDescription] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (props.client.oldCarId !== "") {
      props.addOverview(
        props.login.token,
        props.login.user_id,
        props.client.oldCarId,
        registerationYear,
        manufacturingYear,
        owners,
        transmission,
        color,
        insurance,
        registerationType,
        description
      );
      navigate("/specification");
    }
  };

  const years = Array.from({ length: 25 }, (_, i) => 2025 - i);

  return (
    <div className="old-car-flow-container">
      <StepIndicator currentStep={2} />

      <div className="old-car-flow-card">
        <h2 className="flow-title">Vehicle Overview</h2>
        <p className="flow-subtitle">Provide registration details and ownership history</p>

        <form onSubmit={handleSubmit} className="flow-form">
          <div className="flow-grid">
            <div className="flow-group">
              <label className="flow-label">Registration Year</label>
              <select className="flow-select" value={registerationYear} onChange={(e) => setRegisterationYear(e.target.value)} required>
                <option value="">Select Year</option>
                {years.map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Manufacturing Year</label>
              <select className="flow-select" value={manufacturingYear} onChange={(e) => setManufacturingYear(e.target.value)} required>
                <option value="">Select Year</option>
                {years.map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">No. of Owners</label>
              <select className="flow-select" value={owners} onChange={(e) => setOwners(e.target.value)} required>
                <option value="">Select</option>
                <option value="First Owner">First Owner</option>
                <option value="Second Owner">Second Owner</option>
                <option value="Third or More">Third or More</option>
                <option value="Unregistered Car">Unregistered Car</option>
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Transmission</label>
              <select className="flow-select" value={transmission} onChange={(e) => setTransmission(e.target.value)} required>
                <option value="">Select</option>
                <option value="Automatic">Automatic</option>
                <option value="Manual">Manual</option>
                <option value="Clutchless Manual">Clutchless Manual</option>
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Color</label>
              <input className="flow-input" type="text" placeholder="e.g. Polar White" value={color} onChange={(e) => setColor(e.target.value)} required />
            </div>

            <div className="flow-group">
              <label className="flow-label">Insurance</label>
              <input className="flow-input" type="text" placeholder="e.g. Comprehensive" value={insurance} onChange={(e) => setInsurance(e.target.value)} required />
            </div>

            <div className="flow-group full-width">
              <label className="flow-label">Registration Type</label>
              <select className="flow-select" value={registerationType} onChange={(e) => setregisterationType(e.target.value)} required>
                <option value="">Select Type</option>
                <option value="private">Private</option>
                <option value="commercial">Commercial</option>
              </select>
            </div>

            <div className="flow-group full-width">
              <label className="flow-label">Description / Seller Comments</label>
              <textarea className="flow-textarea" placeholder="Add any additional details about the car's condition or history..." value={description} onChange={(e) => setDescription(e.target.value)} required />
            </div>
          </div>

          <div className="flow-actions">
            <button type="button" className="flow-btn-secondary" onClick={() => navigate(-1)}>Back</button>
            <button type="submit" className="flow-btn-primary">Next Step</button>
          </div>
        </form>
      </div>

      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={props.snackbar.message}
      />
    </div>
  );
}

